module.exports = __webpack_public_path__ + "img/icon4.d152b442.gif";